import cx from 'classnames'
import * as React from 'react'

import styles from './RadioBox.module.scss'
import { Label } from '../Label'

interface BaseRadioProps {
    Component?: React.ElementType
    className?: string
    disabled?: boolean
    inline?: boolean
    children?: React.ReactNode
}

const DefaultRadioInput = (
    props: React.InputHTMLAttributes<HTMLInputElement>,
) => <input type="radio" {...props} />

const RadioBox = <
    // eslint-disable-next-line @typescript-eslint/ban-types
    T extends object = React.InputHTMLAttributes<HTMLInputElement>,
>({
    Component = DefaultRadioInput,
    className,
    disabled,
    children,
    inline,
    ...others
}: BaseRadioProps & T) => (
    <Label
        className={cx(styles.label, { [styles.inline]: inline }, className)}
        disabled={disabled}
    >
        <Component className={styles.input} disabled={disabled} {...others} />
        <div className={styles.radio} />
        {children && <div>{children}</div>}
    </Label>
)

export default RadioBox
